module.exports = __webpack_public_path__ + "static/img/kylin-icon.9d4c1e83.png";